export default defineNuxtPlugin({
  async setup() {
    const { menuItems } = storeToRefs(useMenuStore())

    menuItems.value.push(
      {
        icon: 'mdi:plane',
        label: 'elements.menu.destinations',
        to: { name: 'destinations' },
      },
      {
        icon: 'mdi:island',
        label: 'elements.menu.trips',
        to: { name: 'trips' },
      },
      {
        icon: 'mdi:newspaper-variant-outline',
        label: 'elements.menu.blog',
        to: { name: 'articles' },
      },
      {
        icon: 'mdi:help-box',
        label: 'elements.menu.helpCenter',
        to: { name: 'help' },
      },
    )
  },
})
